<template>
    <section class="all-v">
        <div class="auth-form">
            <h1 :style="theme.header" class="small">Confirm Sign Up</h1>
            <div class="mt-3">
                <label class="label-mini" for="code">Code</label>
                <input class="form-control w-input" v-model="code" id="code" name="code" placeholder="Code" type="text"/>
            </div>
            <div :style="theme.actionRow" class="d-flex justify-content-around">
                <w-button :inverse="true" id="confirm-btn" class="px-4" @click="confirm" :disabled="!tempusername || !code">Confirm</w-button>
                <w-button :inverse="true" class="px-4" @click="resend">Resend</w-button>
            </div>
            <div class="auth-form-footer">
                <span>
                    <a :style="theme.link" v-on:click="signIn">Back to Sign In</a>
                </span>
            </div>
            <div class="alert alert-danger mt-4" v-if="error">{{error}}</div>
        </div>
        <w-version/>
    </section>
</template>

<script>
import { Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import AmplifyTheme from '../../style/AmplifyTheme'

const logger = new Logger('ConfirmSignUpComp')

export default {
    name: 'ConfirmSignUp',
    data () {
        return {
            username: '',
            code: '',
            error: '',
            theme: AmplifyTheme
        }
    },
    computed: {
        user () {
            return this.$store.getters['auth/user']
        },
        tempusername () {
            return this.$store.getters['auth/tempusername']
        }
    },
    methods: {
        confirm (event) {
            Auth.confirmSignUp(this.tempusername, this.code).then(() => {
                return this.$router.push('/').catch(err => err)
            }).catch(err => {
                return this.setError(err)
            })
        },
        resend () {
            Auth.resendSignUp(this.tempusername).then(() => {
                return logger.debug('code resent')
            }).catch(err => {
                return this.setError(err)
            })
        },
        signIn () {
            this.$router.push('/auth/signIn')
        },
        setError (err) {
            this.error = err ? err.message || err : ''
        }
    }
}
</script>

<style scoped>
    h1 {
        font-size: 28px !important;
        font-weight: 500 !important;
        color: #1a3f65 !important;
    }

    .auth-form {
        display: inline-block;
        width: 320px;
        margin-top: 85px;
        padding-top: 15px;
    }

    .auth-form-footer {
        display: flex;
        margin-top: 1em;
        justify-content: space-between;
    }

    .auth-form-footer a {
        color: #23B8DC;
    }

    @media (max-width: 576px) {
        .all-v {
            padding-left: 17px;
            padding-right: 17px;
        }

        .auth-form {
            display: block;
            width: 100%;
            max-width: 320px;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
